import React from 'react';
import { SpeechToTextLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingSpeechToTextConfig } from '@/data/landingConfig/landingSpeechToTextConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_SpeechToText } from './schemaObject';

interface Props {}
const SpeechToText: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_SpeechToText} />
			<SpeechToTextLandingTemplate
				data={landingSpeechToTextConfig}
				funnelLinkService={GenerateLandingLinkService.funnelSpeechToText()}
			/>
		</>
	);
};

export default SpeechToText;
